ui-cms-container {
  ui-container {
    .mgnlEditorBar ~ * {
      margin-top: 0;
    }
  }
}
